/* 新版 PDP 变体轨道鼠标拖动；触屏和键盘继续走原生行为。 */
(function () {
  if (window.__pdpVariantScrollReady) return;
  window.__pdpVariantScrollReady = true;
  const sections = new WeakMap();

  function init(root) {
    if (sections.has(root)) return;
    const controller = new AbortController();
    const options = { signal: controller.signal };
    const observer = new ResizeObserver(entries => {
      entries.forEach(({ target }) => {
        target.classList.toggle('is-mouse-scrollable', target.scrollWidth > target.clientWidth + 1);
      });
    });
    root.querySelectorAll('.pm-pills').forEach(track => {
      let gesture = null;
      let suppressClick = false;
      observer.observe(track);

      track.addEventListener('pointerdown', event => {
        suppressClick = false;
        if (event.pointerType !== 'mouse' || event.button !== 0 || track.scrollWidth <= track.clientWidth) return;
        gesture = { id: event.pointerId, x: event.clientX, scroll: track.scrollLeft, dragging: false };
      }, options);
      track.addEventListener('pointermove', event => {
        if (!gesture || gesture.id !== event.pointerId) return;
        if (!(event.buttons & 1)) { finish(); return; }
        const delta = event.clientX - gesture.x;
        if (!gesture.dragging && Math.abs(delta) < 5) return;
        if (!gesture.dragging) {
          gesture.dragging = true;
          track.setPointerCapture(event.pointerId);
          track.classList.add('is-mouse-dragging');
        }
        event.preventDefault();
        track.scrollLeft = gesture.scroll - delta;
      }, options);
      function finish() {
        if (!gesture) return;
        suppressClick = gesture.dragging;
        const id = gesture.id;
        gesture = null;
        track.classList.remove('is-mouse-dragging');
        if (track.hasPointerCapture(id)) track.releasePointerCapture(id);
      }
      track.addEventListener('pointerup', finish, options);
      track.addEventListener('pointercancel', finish, options);
      track.addEventListener('lostpointercapture', finish, options);
      track.addEventListener('pointerleave', () => {
        if (gesture && !gesture.dragging) finish();
      }, options);
      track.addEventListener('dragstart', event => event.preventDefault(), options);
      // 在现有变体按钮 click 处理器之前拦截拖动产生的点击；键盘点击不受影响。
      track.addEventListener('click', event => {
        if (!suppressClick || event.detail === 0) return;
        suppressClick = false;
        event.preventDefault();
        event.stopImmediatePropagation();
      }, { ...options, capture: true });
    });
    sections.set(root, () => { controller.abort(); observer.disconnect(); });
  }

  function scan(scope) {
    if (scope.matches?.('.product-main--annie')) init(scope);
    scope.querySelectorAll('.product-main--annie').forEach(init);
  }
  scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => {
    const roots = event.target.matches('.product-main--annie') ? [event.target] : event.target.querySelectorAll('.product-main--annie');
    roots.forEach(root => { sections.get(root)?.(); sections.delete(root); });
  });
})();
